import React from 'react';
import './styling.css';

function TextInputComponent({ question, value, onChange }) {
  return (
    <div className="text-input-container">
      <label className="text-input-label">
        {question.Text}
        {question['Required?'] &&
          question['Required?'].toLowerCase() === 'yes' && (
            <span className="text-input-required">*</span>
          )}
      </label>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="text-input-field"
      />
    </div>
  );
}

export default TextInputComponent;
